import Table from './Table'
import BadgeEstado from './BadgeEstado'
import BadgeTipo from './BadgeTipo'

const components = {
  SolicitudBadgeEstado: BadgeEstado,
  SolicitudBadgeTipo: BadgeTipo,
  SolicitudesTable: Table,
}

// eslint-disable-next-line no-unused-vars
export default (Vue, options) => {
  Object.keys(components).forEach(component => Vue.component(component, components[component]))
}
